import React from 'react'
import {NotificationContainer} from 'react-notifications'
import {useSelector, shallowEqual} from 'react-redux'
import styled from 'styled-components'

import { NavigationLoader } from '../../components/loader'
import { Sidebar as LeftSidebar } from '../../components/left-sidebar'
import { Navbar } from '../../components/navbar'
import Backdrop from '../../components/backdrop'

import './styles.css'

const Page = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    
    background-color: var(--it-bg-dark-2);
    box-sizing: border-box;
    padding: 14px;
    margin: 20px 20px 20px 0;
`

const MainWrapper = styled.div`
    width: 100%;
`

const HorizontalLine = styled.div`
    width: 100%;
    height: 1px;
    margin: 12px 0;
    background: var(--it-stroke-grey);
`

export const Main = ({children}) => {
    const {uiConfig} = useSelector(
        (state) => ({
            uiConfig: state.uiConfig,
        }),
        shallowEqual
    )
    const {layout, collapsed, backgroundTheme, navbarTheme, leftSidebarTheme} = {...uiConfig}

    return (
        <div
            data-layout={layout}
            data-collapsed={collapsed}
            data-background={backgroundTheme}
            data-navbar={navbarTheme}
            data-left-sidebar={leftSidebarTheme}
            className={`${backgroundTheme === 'dark' ? 'dark-mode' : 'default-mode'}`}>
            <NavigationLoader/>
            <Backdrop/>
            <NotificationContainer/>
          <div className="wrapper">
              <LeftSidebar collapsed={collapsed}/>
              <MainWrapper className="main"
                   style={{backgroundColor: 'unset', border: 'none'}}>
                <Page>
                  <Navbar/>
                  <HorizontalLine />
                  <div className="min-h-screen w-full">{children}</div>
                </Page>
              </MainWrapper>
          </div>
        </div>
    )
}

export default Main